<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="规则名称">
              <a-input placeholder="请输入规则名称" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'warnRule:add'">新增</a-button>
      <a-button type="primary" icon="download" v-has="'warnRule:export'" @click="handleExportXls('预警规则')">导出</a-button>
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:2000}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <template slot="statusAction" slot-scope="text,record">
          <a-switch checked-children="开启" un-checked-children="关闭" v-model="record.status == 'Y'"   @change="statusSwitchChange(record,$event)" />
        </template>

        <span slot="action" slot-scope="text, record">
          <a v-has="'warnRule:edit'" @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a v-has="'warnRule:detail'" @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a v-has="'warnRule:delete'">删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <pre-warn-rule-modal ref="modalForm" @ok="modalFormOk"></pre-warn-rule-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import PreWarnRuleModal from './modules/PreWarnRuleModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import {  httpAction,getAction,postAction} from '@/api/manage' 


  export default {
    name: 'PreWarnRuleList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      PreWarnRuleModal
    },
    data () {
      return {
        description: '预警规则管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'规则名称',
            align:"center",
            dataIndex: 'name',
            ellipsis:true,
            width:200,
          },
          {
            title:'预警类型',
            align:"center",
            dataIndex: 'warnType_dictText'
          },
          {
            title:'核酸时间配置',
            align:"center",
            dataIndex: 'detectionTime',
            customRender:function (text,row,index) {
              if(row.detectionUnit=='小时'){
                return text+'小时';
              }else if(row.detectionUnit=='天'){
                return text+'天';
              }else{
                return text;
              }
            }
          },
          {
            title:'提前预警时间',
            align:"center",
            dataIndex: 'beforeWarnTime_dictText',
            customRender:function (text,row,index) {
              return text+'小时';
            }
          },
          {
            title:'预警厂区',
            align:"center",
            dataIndex: 'factoryNames',
            ellipsis:true,
            width:200,
          },
          {
            title:'预警区域',
            align:"center",
            dataIndex: 'areaNames',
            ellipsis:true,
            width:200,
          },
          {
            title:'预警楼栋',
            align:"center",
            dataIndex: 'buildingNames',
            ellipsis:true,
            width:200,
          },

          {
            title:'创建者',
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title:'创建时间',
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title:'启用时间',
            align:"center",
            dataIndex: 'updateTime'
          },
          {
            title:'是否启用',
            align:"center",
            dataIndex: 'status',
            scopedSlots: { customRender: 'statusAction' }
          },


          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/prevent/warn/list",
          delete: "/prevent/warn/delete",
          deleteBatch: "/prevent/warn/deleteBatch",
          exportXlsUrl: "/prevent/warn/export-xls",
          
          
        },
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {
      // this.$set(this.dictOptions, 'status', [{text:'是',value:'Y'},{text:'否',value:'N'}])
    },
    computed: {
      
    },
    methods: {

      statusSwitchChange(record,checked) {//开启/关闭
        if(checked){
            record.status ='Y'
        }else{
            record.status ='N'
        }
        
        httpAction('/prevent/warn/enableRule', record, 'put').then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.$emit('ok')
          } else {
            this.$message.warning(res.message)
          }
        })
      },


    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
